<template>
  <div class="toss-return">
    <div class="toss-return__card" :class="outcome === 'fail' ? 'is-fail' : 'is-wait'">
      <p class="toss-return__kicker">{{ outcome === 'success' ? '카드 · 간편결제' : '결제 중단' }}</p>
      <h1>{{ title }}</h1>
      <p class="toss-return__message">{{ message }}</p>
      <router-link v-if="orderPath" class="toss-return__go" :to="orderPath">주문에서 확인</router-link>
      <router-link v-else class="toss-return__go" to="/mall/cart">장바구니로</router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { confirmTossPayment } from '@/api/mallOrder'

const props = defineProps<{
  outcome: 'success' | 'fail'
}>()

const route = useRoute()
const router = useRouter()
const message = ref(props.outcome === 'success' ? '결제를 확인하고 있습니다. 잠시만 기다려 주세요.' : '')
const orderCode = ref('')

const title = computed(() => (props.outcome === 'success' ? '결제를 확인하고 있습니다' : '결제가 끝나지 않았습니다'))

const orderPath = computed(() => (orderCode.value ? `/mall/orders/${orderCode.value}` : ''))

onMounted(async () => {
  if (props.outcome === 'fail') {
    orderCode.value = String(route.query.orderId || '')
    message.value = String(route.query.message || '결제를 마치지 않았습니다. 주문에서 다시 결제할 수 있습니다.')
    return
  }

  const paymentKey = String(route.query.paymentKey || '')
  const orderId = String(route.query.orderId || '')
  const amount = Number(route.query.amount)
  orderCode.value = orderId

  if (!paymentKey || !orderId || !Number.isInteger(amount)) {
    message.value = '결제 정보가 없습니다. 주문에서 다시 시도해 주세요.'
    return
  }

  try {
    await confirmTossPayment(orderId, { paymentKey, amount })
    router.replace(`/mall/orders/${orderId}`)
  } catch (error) {
    message.value = error instanceof Error ? error.message : '결제 승인에 실패했습니다.'
  }
})
</script>

<style lang="scss" src="./MallTossReturnPage.scss"></style>
